module.exports = __webpack_public_path__ + "static/media/upload_csv.64e72c17.svg";